<template>
  <div
    class="modal has-overflow"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Enter Order Date and Expected Delivery Date
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <div class="modal-card-body">

          <v-form :valid.sync="valid" class="columns is-multiline">
            <div class="column is-half">
              <label class="label">Shipping Date*</label>
              <v-datetimepicker
                required
                horizontal-time-picker
                v-model="shipping.shipped_on"/>
            </div>
            <div class="column is-half">
              <label class="label">Truck Driver Name*</label>
              <v-text-field
                required
                placeholder="Truck driver's name"
                v-model="shipping.truck_driver_name"/>
            </div>
            <div class="column is-half">
              <label class="label">Truck Driver Phone Number*</label>
              <v-text-field
                required
                placeholder="Truck driver's phone number"
                v-model="shipping.truck_driver_phone"/>
            </div>
            <div class="column is-half">
              <label class="label">Truck Number/ License Plate*</label>
              <v-text-field
                required
                placeholder="Truck Number or License Plate"
                v-model="shipping.truck_driver_lp"/>
            </div>
          </v-form>

          <hr>

          <label class="label">Shipment Images</label>

          <div 
            class="level my-3"
            v-for="(file, i) in files"
            :key="i">
            <div class="level-left">
              <span
                @click="remove(i)" 
                class="icon">
                <i class="fas fa-times"></i>
              </span>
              <v-file-upload
                file-type-validator=".*"
                :value="file"
                @input="update(i, $event)"
                has-name/>
            </div>
          </div>

          <button
            @click.prevent="addFile()" 
            class="button is-small is-primary mt-2">
            <span class="icon">
              <i class="fas fa-plus"></i>
            </span>
            <span>Add another file</span>
          </button>

        </div>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.once="save()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import VDatetimepicker from '@/components/base/VDatetimepicker'
import VFileUpload from '@/components/base/VFileUpload'

export default {
  props: {
    value: {
      type: Boolean
    },
    delivery: {
      type: Object
    }
  },
  components: { VForm, VDatetimepicker, VTextField, VFileUpload },
  data() {
    return {
      shipping: {
        shipped_on: null,
        truck_driver_name: null,
        truck_driver_phone: null,
        truck_driver_lp: null
      },
      files: [],
      valid: false,
      fileTemplate: {
        file: null,
        name: null,
        url: null
      }
    }
  },
  created() {
    this.addFile();
  },
  methods: {
    addFile() {
      this.files.push(
        Object.assign({}, this.fileTemplate)
      );
    },
    update(i, v) {
      this.files.splice(i, 1, v);
    },
    remove(i) {
      this.files.splice(i, 1);
    }, 
    save() {
      this.$emit('save', { 
        data: this.shipping,
        files: this.files
      });
      this.close(true);
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/modal.scss';

.fa-times:hover {
  color:#FF3860;
  cursor: pointer;
}
</style>